import fetch from "node-fetch";
import { database } from "../firebase";

export const retrieveListDetails = async (body) => {
  try {
    const response = await fetch(`/api/brreg/fetch-list-size`, {
      method: "POST",
      body: body ? JSON.stringify(body) : null,
      headers: { "Content-Type": "application/json" },
    });
    const data = await response.json();
    return {
      error: null,
      payload: { size: data.page.totalElements, url: data._links.self.href },
    };
  } catch (e) {
    throw new Error(e);
  }
};

export const createNewList = async (details) => {
  try {
    await database
      .collection("companies")
      .doc(details.company)
      .collection("lists")
      .add(details.list);
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};
